/**
 * Compiled CSS value of $elevation-x-small.
 * Keep in sync with @wordpress/base-styles/_variables.scss.
 */
export const ELEVATION_X_SMALL =
	'0 1px 1px rgba(0, 0, 0, 0.03), 0 1px 2px rgba(0, 0, 0, 0.02), 0 3px 3px rgba(0, 0, 0, 0.02), 0 4px 4px rgba(0, 0, 0, 0.01)';
